import { render, staticRenderFns } from "./NotificationError.vue?vue&type=template&id=8d86a168&"
import script from "./NotificationError.vue?vue&type=script&lang=ts&"
export * from "./NotificationError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports